export const opBindings = {
  startswith: 'starts with',
  endswith: 'ends with',
  eq: '=',
  neq: '≠',
  isnull: 'is NULL',
  isnotnull: 'not NULL',
  lt: '<',
  lte: '≤',
  gt: '>',
  gte: '≥',
  contains: 'contains',
  doesnotcontain: 'not contains',
  isempty: 'empty',
  isnotempty: 'not empty',
  in: 'in',
}
